import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { ViewProps } from './rive.constants';
import { ImageViewFit } from '../image/image-static-preview';

const RiveStaticPreview = ({ properties }: ViewProps) => {
  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(properties.dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageViewFit imageUrls={properties.imageUrls || []} />
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default RiveStaticPreview;
